import { cva } from '@/styled-system/css';

export const toastIconStyles = cva({
  base: {
    marginInlineEnd: 'default',
  },
  variants: {
    tone: {
      info: {
        color: 'Toast.info.icon-leading',
      },
      success: {
        color: 'Toast.success.icon-leading',
      },
      warning: {
        color: 'Toast.warning.icon-leading',
      },
      critical: {
        color: 'Toast.critical.icon-leading',
      },
    },
  },
});
